// @flow

import * as React from 'react';
import ValuePropositionItem from './ValuePropositionItem';
import { getContent, getHeader } from './text';

const DesktopValuePropositionSkeleton = () => (
  <React.Fragment>
    <ValuePropositionItem
      header={getHeader(0)}
      content={getContent(0)}
      imageSrc="img2/branding/homepage/messaging/cruise-icon-reviews.png"
    />
    <ValuePropositionItem
      header={getHeader(1)}
      content={getContent(1)}
      imageSrc="/img2/branding/homepage/messaging/attractions-icon-free-cancel.png"
    />
    <ValuePropositionItem
      header={getHeader(2)}
      content={getContent(2)}
      imageSrc="img2/branding/homepage/messaging/cruise-icon-low-price.png"
    />
  </React.Fragment>
);

export default DesktopValuePropositionSkeleton;
